import React from 'react';
import List from '../ui/List';

const TeacherList = ({ teachers }) => {
    const renderTeacher = (teacher) => (
        <li key={teacher.id} className="py-3 flex justify-between items-center">
            <div className="flex flex-col">
                <span className="font-semibold">{teacher.name}</span>
                <span className="text-sm text-gray-500">{teacher.email}</span>
            </div>
        </li>
    );

    return (
        <div>
            <h3 className="text-lg font-semibold mb-2">Teachers</h3>
            <List items={teachers} renderItem={renderTeacher} />
        </div>
    );
};

export default TeacherList;
